module.exports = __webpack_public_path__ + "img/icons BFr_8.71031147.png";